var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerformance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 24C13.2838 23.9968 15.9527 22.8896 17.9211 20.9211C19.8896 18.9527 20.9968 16.2838 21 13.5C21 13.3674 20.9473 13.2402 20.8536 13.1464C20.7598 13.0527 20.6326 13 20.5 13H11.5C11.3674 13 11.2402 12.9473 11.1464 12.8536C11.0527 12.7598 11 12.6326 11 12.5V3.5C11 3.36739 10.9473 3.24021 10.8536 3.14645C10.7598 3.05268 10.6326 3 10.5 3C7.71523 3 5.04451 4.10625 3.07538 6.07538C1.10625 8.04451 0 10.7152 0 13.5C0 16.2848 1.10625 18.9555 3.07538 20.9246C5.04451 22.8938 7.71523 24 10.5 24Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0C13.3674 0 13.2402 0.0526784 13.1464 0.146447C13.0527 0.240215 13 0.367392 13 0.5V10C13 10.2652 13.1054 10.5196 13.2929 10.7071C13.4804 10.8946 13.7348 11 14 11H23.5C23.6326 11 23.7598 10.9473 23.8536 10.8536C23.9473 10.7598 24 10.6326 24 10.5C23.9968 7.7162 22.8896 5.04733 20.9211 3.07889C18.9527 1.11044 16.2838 0.00317604 13.5 0V0Z",
    fill: "current"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.13219683c2d4b443271220dd97255a4e.svg";
export { ForwardRef as ReactComponent };